import React, { useState } from 'react';
import { Menu, Input, Icon } from 'semantic-ui-react';
import CardMCCompareAppointmentSelfAndStaff from './CardMCCompareAppointmentSelfAndStaff';
import CardMCAppointmentSuccessRate from './CardMCAppointmentSuccessRate';
import CardMC2Panel from './CardMC2Panel';

type CardMCAppointmentBehaviorProps = {
  // Add props if needed
  controller: any;
  runSequence: any;
  MeChartSequence: any;
}


const CardMCAppointmentBehavior = (props: CardMCAppointmentBehaviorProps) => {
  const [activeItem, setActiveItem] = useState('mobVsDesk');
  const [filterText, setFilterText] = useState('');

  const menuItems = [
    { id: 'mobVsDesk', label: 'จำนวนนัดหมาย Self / Staff Booking' },
    { id: 'ratioSuccess', label: 'อัตราการนัดหมายแล้วไม่มา / ยกเลิกนัดหมาย' },
  ];

  const filteredItems = menuItems.filter(item =>
    item.label.toLowerCase().includes(filterText.toLowerCase())
  );

  const leftPanelContent = (
    <>
      <div className="search-container">
        <Input
          icon='search'
          placeholder='Search reports...'
          fluid
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
      </div>
      <Menu fluid vertical tabular className="nav-menu">
        {filteredItems.map(item => (
          <Menu.Item
            key={item.id}
            active={activeItem === item.id}
            onClick={() => setActiveItem(item.id)}

          >
            <div className="item-content">
              <span>{item.label}</span>
              {activeItem === item.id && <Icon name='chevron right' className="icon" />}
            </div>
          </Menu.Item>
        ))}
      </Menu>
    </>
  );

  return (
    <div id="card-mc-appointment-behavior">
      <CardMC2Panel
        leftPanel={
          <div className="left-panel-container">
            {leftPanelContent}
          </div>
        }
        rightPanel={
          <div className="right-panel-container">
            {activeItem === 'mobVsDesk' && <CardMCCompareAppointmentSelfAndStaff controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence}/>}
            {activeItem === 'ratioSuccess' && <CardMCAppointmentSuccessRate controller={props.controller} runSequence={props.runSequence} MeChartSequence={props.MeChartSequence}/>}
          </div>
        }
      />
    </div>
  );
};

export default CardMCAppointmentBehavior;
